import type { SVGProps } from 'react';

export const PagesIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg width={31} viewBox="0 0 31 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M.947 0h22v22h-22zm17 6h-12v3h12zm0 7h-12v3h12z"
			fill="currentColor"
		/>
		<path d="M26.947 9v16h-16v4h20V9z" fill="currentColor" />
	</svg>
);
